import Conversations from './Conversations.vue';

export default Conversations;
